import React, { useState } from 'react';
import '../styles/Header.css';
import logo from '../assets/tact_logo.svg';

const Header = () => {
  const [activeLink, setActiveLink] = useState('Página inicial');
  const [menuOpen, setMenuOpen] = useState(false); // controla menu mobile

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClick = (name) => {
    setActiveLink(name);
    setMenuOpen(false); // fecha menu ao clicar
  };

  return (
    <header className="header">
      {/* Hamburger menu (mobile) */}
      <div className="hamburger" onClick={toggleMenu}>
        <span />
        <span />
        <span />
      </div>

      {/* Menu de links */}
      <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <a
          href="#inicio"
          className={`nav-button ${activeLink === 'Página inicial' ? 'active' : ''}`}
          onClick={() => handleClick('Página inicial')}
        >
          Página inicial
        </a>
        <a
          href="#funcionalidades"
          className={`nav-button ${activeLink === 'Funcionalidades' ? 'active' : ''}`}
          onClick={() => handleClick('Funcionalidades')}
        >
         Funcionalidades
        </a>
        <a
          href="#plano-franquia"
          className={`nav-button ${activeLink === 'Planos' ? 'active' : ''}`}
          onClick={() => handleClick('Planos')}
        >
          Planos
        </a>
        <a
          href="#contato-suporte"
          className={`nav-button ${activeLink === 'Contato e suporte' ? 'active' : ''}`}
          onClick={() => handleClick('Contato e suporte')}
        >
          Contato e suporte
        </a>
      </nav>

      {/* Logo no canto direito */}
      <a href="#inicio" className="logo-link" onClick={() => handleClick('Página inicial')}>
        <img src={logo} alt="Minha Landing Page" className="logo" />
      </a>
    </header>
  );
};

export default Header;
